import React from 'react';
import Comment from '../comment';
import ReplyComment from '../reply-comments';
import Div from '@pezeshk-book/ui-kit/div';
import ReplyButton from '../reply-button';
import { CommentsProps } from '../comments.props';
import { Rating } from '@pezeshk-book/ui-kit';

const TemplateComment = (
  {
    id,
    user_name: userName,
    content,
    created_at: createdAt,
    replies,
    loginHandler,
    replyHandler,
    is_buyer: isBuyer,
    score,
  }: CommentsProps) => {
  const clickReplyHandler = () => {
    replyHandler({ id: id, name: userName });
  };

  return (
    <Div className={'flex-col w-full bg-darkBlue-50 gap-4 p-4 sm:p-7 shadow-lg rounded-lg'}>
      <Comment
        isBuyer={isBuyer}
        user_name={userName}
        content={content}
        created_at={createdAt}
      />
      <Div className={`w-full ${score ? 'justify-between' : 'justify-end'}`}>
        {score ? (
          <Rating
            direction={'rtl'}
            readOnly={true}
            value={score}
            size={'large'}
          />
        ) : null}
        <ReplyButton
          replyHandler={clickReplyHandler}
          loginHandler={loginHandler}
        />
      </Div>
      <ReplyComment list={replies}/>
    </Div>
  );
};

export default TemplateComment;
